var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollorDonor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9358_259)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#268262"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9358_259",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 11,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 11,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9358_259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0247 32C22.7414 32 22.5039 31.9042 22.3122 31.7125C22.1206 31.5208 22.0247 31.2833 22.0247 31V29.85C21.2747 29.6833 20.6164 29.3917 20.0497 28.975C19.4831 28.5583 19.0247 27.975 18.6747 27.225C18.5581 26.9917 18.5539 26.7458 18.6622 26.4875C18.7706 26.2292 18.9664 26.0417 19.2497 25.925C19.4831 25.825 19.7247 25.8292 19.9747 25.9375C20.2247 26.0458 20.4164 26.225 20.5497 26.475C20.8331 26.975 21.1914 27.3542 21.6247 27.6125C22.0581 27.8708 22.5914 28 23.2247 28C23.9081 28 24.4872 27.8458 24.9622 27.5375C25.4372 27.2292 25.6747 26.75 25.6747 26.1C25.6747 25.5167 25.4914 25.0542 25.1247 24.7125C24.7581 24.3708 23.9081 23.9833 22.5747 23.55C21.1414 23.1 20.1581 22.5625 19.6247 21.9375C19.0914 21.3125 18.8247 20.55 18.8247 19.65C18.8247 18.5667 19.1747 17.725 19.8747 17.125C20.5747 16.525 21.2914 16.1833 22.0247 16.1V15C22.0247 14.7167 22.1206 14.4792 22.3122 14.2875C22.5039 14.0958 22.7414 14 23.0247 14C23.3081 14 23.5456 14.0958 23.7372 14.2875C23.9289 14.4792 24.0247 14.7167 24.0247 15V16.1C24.6581 16.2 25.2081 16.4042 25.6747 16.7125C26.1414 17.0208 26.5247 17.4 26.8247 17.85C26.9747 18.0667 27.0039 18.3083 26.9122 18.575C26.8206 18.8417 26.6331 19.0333 26.3497 19.15C26.1164 19.25 25.8747 19.2542 25.6247 19.1625C25.3747 19.0708 25.1414 18.9083 24.9247 18.675C24.7081 18.4417 24.4539 18.2625 24.1622 18.1375C23.8706 18.0125 23.5081 17.95 23.0747 17.95C22.3414 17.95 21.7831 18.1125 21.3997 18.4375C21.0164 18.7625 20.8247 19.1667 20.8247 19.65C20.8247 20.2 21.0747 20.6333 21.5747 20.95C22.0747 21.2667 22.9414 21.6 24.1747 21.95C25.3247 22.2833 26.1956 22.8125 26.7872 23.5375C27.3789 24.2625 27.6747 25.1 27.6747 26.05C27.6747 27.2333 27.3247 28.1333 26.6247 28.75C25.9247 29.3667 25.0581 29.75 24.0247 29.9V31C24.0247 31.2833 23.9289 31.5208 23.7372 31.7125C23.5456 31.9042 23.3081 32 23.0247 32Z",
    fill: "#FAFAFA"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9358_259",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9358_259"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9358_259",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollorDonor);
export default __webpack_public_path__ + "static/media/dollor-donor.45e3e11f54c8472aaae89d9dbae95187.svg";
export { ForwardRef as ReactComponent };